
import {
    defineComponent,
    ref
} from "vue";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";
import {
    isFullScreen,
    toggleFullScreen
} from "../utils/common";

export default defineComponent({
    name: "CigoToolsBar",
    components: {
        CigoIconFont
    },
    setup() {
        let fullScreenFlag = ref(isFullScreen());
        const clickFullScreen = () => {
            toggleFullScreen();
            setTimeout(() => {
                fullScreenFlag.value = isFullScreen();
            }, 100);
        };
        return {
            fullScreenFlag,
            clickFullScreen,
            isFullScreen,
            toggleFullScreen
        };
    }
});
